<template>
  <v-container
    fluid
    class="fill-height"
  >
    <!-- Propiedades -->
    <PropertyWindow v-if="editing">
      <component :is="selectedItem?.settings?.component_property_window" />
    </PropertyWindow>

    <!-- Menú lateral izquierdo (páginas y toolbar) -->
    <LeftMenu
      v-if="editing"
      :tools="herramientas"
    />
    <!-- Pantalla principal -->
    <ScadaPage v-if="actualPage()"></ScadaPage>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import PropertyWindow from "@/components/layout/PropertyWindow";
import LeftMenu from "@/components/layout/LeftMenu";
import ScadaPage from "@/components/layout/ScadaPage";

export default {
  components: {
    PropertyWindow,
    LeftMenu,
    ScadaPage,
  },

  data() {
    return {
      herramientas: [],
    };
  },

  computed: {
    ...mapState(["selectedItem", "editing"]),
  },

  methods: {
    ...mapGetters(["actualPage"]),
    ...mapActions(["loadPages"]),

    async loadTools() {
      let modulesReq = require.context("../../plugins", true, /\.json$/, "lazy");
      modulesReq.keys().forEach(async (k) => {
        //Eliminar "./"
        if ((k.match(/\//g) || []).length < 3) {
          const plugin_name = k.substring(2);

          //Localizar raíz
          let index = plugin_name.lastIndexOf("/");
          const root = plugin_name.substring(0, index);

          let myPlugin = await require(`@/plugins/${plugin_name}`);
          myPlugin.root = `plugins/${root}`;
          this.herramientas.push(myPlugin);
        }
      });
    },
  },

  async created() {
    //lectura de los plugins
    await this.loadPages();
    await this.loadTools();
    await this.$nextTick();
  },
};
</script>

<style></style>
